// Firebase Configuration
// Replace these values with your Firebase project configuration
// Get these from: Firebase Console > Project Settings > General > Your apps > Web app

export const firebaseConfig = {
  apiKey: "AIzaSyATDWduAgsGN8rko8g8woQturyxUvPSAgs",
  authDomain: "terre-et-ciel-maraichage.firebaseapp.com",
  databaseURL: "https://terre-et-ciel-maraichage-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "terre-et-ciel-maraichage",
  storageBucket: "terre-et-ciel-maraichage.firebasestorage.app",
  messagingSenderId: "502541554689",
  appId: "1:502541554689:web:07670a8844f3f928f09c00",
  measurementId: "G-2PLZFHYKF1",
};

// Set to true once you've configured Firebase
export const FIREBASE_ENABLED = true;
